

import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png"
import colorSharp2 from "../assets/img/color-sharp2.png"
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import {
  VerticalTimeline,
  VerticalTimelineElement
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import SchoolIcon from "@mui/icons-material/School";
import WorkIcon from "@mui/icons-material/Work";
import StarRateIcon from "@mui/icons-material/StarRate";
import img from "../assets/img/MyPic.jpg";
////
import React from "react";
import "./Timeline.css";



export const About = () => {
  
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };
    
    

  return (
    <section   className="about" >
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="about-bx wow zoomIn">
                    <h2 id="about" className="about section" >About</h2>
          <div className='p-img'>
            <div >
              <img
              className="home-img" id="abc"
                src={img}
                alt="Images"
              />
            </div>
            <div>
            {/* <h2>About</h2> */}
                        <p>
                Hi Everyone, I am{" "}
                <span className="different">Akshay Kumar Gaurav </span> from{" "}
                <span > Saharsa, Bihar</span>. I have
                completed my graduation in Bachelor of Arts from 
                Bhupendra Narayan Mandal University, Madhepura, Bihar.
                <br />
                <br />
                Some of my interests apart form Coding :
                <br />
                <br />
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Watching Science-Fiction Movies
                <br />
                <br /><span className="icons">
                  <ExitToAppIcon />
                </span>
                Reading Books
                <br />
                <br />
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Riding Bikes
                <br />
                <br />
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Travelling
              </p>
              </div>
          </div>
              <h2 className="section__title" data-aos="fade-right">
          My <span className="different">Timeline 💫</span>
        </h2>
          
              <VerticalTimeline  >
          <VerticalTimelineElement
            date={"October 2023 - Present"}
            contentStyle={{
              boxShadow: `#23283E`,
              backgroundColor: `#23283E`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`
            }}
            contentArrowStyle={{ borderRight: "16px solid  rgb(33, 150, 243)" }}
            iconStyle={{
              backgroundColor: `rgb(33, 150, 243)`,
              color: `var(--clr-primary)`
            }}
            icon={<WorkIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Assessment Assistant
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              Masai School
            </h4>
            <p data-aos="fade-right">
            In my role as an Assessment Assistant at Masai, I empower juniors through thorough evaluations, primarily focusing on Data Structures and Algorithms (DSA) and coding skills. I conduct interviews, offer feedback, and guide them for ongoing improvement, witnessing their growth firsthand.

            </p>
          </VerticalTimelineElement>
            <VerticalTimelineElement
            date={"October 2022 - Present"}
            contentStyle={{
              boxShadow: `#e324a050`,
              backgroundColor: `#e324a050`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`
            }}
            contentArrowStyle={{ borderRight: "16px solid  rgb(33, 150, 243)" }}
            iconStyle={{
              backgroundColor: `rgb(33, 150, 243)`,
              color: `var(--clr-primary)`
            }}
            icon={<SchoolIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Student
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              Masai School (Remote)
            </h4>
            <p data-aos="fade-right">
              Joined the Military style Bootcamp to learn Software Development
              and Data Structures. Also learned many soft skills in the process.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={"Sept 2020 - July 2023"}
            contentStyle={{
              boxShadow: `#23283E`,
              backgroundColor: `#23283E`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`
            }}
            contentArrowStyle={{ borderRight: "16px solid  rgb(33, 150, 243)" }}
            iconStyle={{
              backgroundColor: `rgb(33, 150, 243)`,
              color: `var(--clr-primary)`
            }}
            icon={<SchoolIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Bachelor of Arts, English Honors
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
            </h4>
            <p data-aos="fade-right">
              B.N Mandal University, Madhepura, Bihar
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={"March 2020"}
            contentStyle={{
              boxShadow: ` #e324a050`,
              backgroundColor: ` #e324a050`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`
            }}
            contentArrowStyle={{ borderRight: "16px solid  rgb(33, 150, 243)" }}
            iconStyle={{
              backgroundColor: `rgb(33, 150, 243)`,
              color: `var(--clr-primary)`
            }}
            icon={<SchoolIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Completed Higher Secondary - Science
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
            </h4>
            <p data-aos="fade-right">P.N.S +2 H/S, Saharsa, Bihar
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            icon={<StarRateIcon />}
            iconStyle={{
              backgroundColor: `rgb(33, 150, 243)`,
              color: `var(--clr-primary)`
            }}
          ></VerticalTimelineElement>
        </VerticalTimeline>
                        
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image" src={colorSharp} alt="Image" />
        <img className="bg-img" src={colorSharp2} alt="Image" />
    </section>
  )
}